import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicLimitation({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.43 12.5c.28 0 .5.22.5.5v.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5V13c0-.28.22-.5.5-.5zM4.8 5.25c.38 0 .7.28.75.65v3.46l.82-.8A.75.75 0 017.5 9.58l-.07.08-2.1 2.03-.06.05-.05.04-.05.03-.04.02-.1.04-.1.02a.76.76 0 01-.45-.06l-.1-.06-.03-.03-.06-.05-2.1-2.03a.75.75 0 01.96-1.15l.09.07.82.79V6c0-.41.33-.75.75-.75zm6.28-1.15h.08l.11.03.1.04.04.02.05.03.05.04.06.05 2.1 2.03.07.08c.23.3.2.72-.05.98a.76.76 0 01-1.07.02l-.82-.79v3.46a.75.75 0 01-1.5-.1V6.63l-.82.8-.09.06a.75.75 0 01-.96-1.16l2.1-2.02.06-.05.04-.03.1-.06a.76.76 0 01.43-.06zM13.43 2c.28 0 .5.22.5.5V3a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-.5c0-.28.22-.5.5-.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicLimitation.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicLimitation.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicLimitation svgRef={ref} {...props} />);
export default ForwardRef;
